"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GlobalProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var GlobalContext = /*#__PURE__*/_react["default"].createContext({
  lcpImage: null
});

var GlobalProvider = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$lcpImage = _ref.lcpImage,
      lcpImage = _ref$lcpImage === void 0 ? null : _ref$lcpImage,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(GlobalContext.Provider, {
    value: {
      // lcpImage for performance optimization
      lcpImage: lcpImage
    }
  }, children);
});

exports.GlobalProvider = GlobalProvider;
var _default = GlobalContext;
exports["default"] = _default;